<template>
  <datalogger-dialog
    class="dataloggerDialog addDeviceBox"
    :visible.sync="dialogVisible"
    :title="editing ? $t('datalogger.editDatalogger') : $t('datalogger.add')"
    :width="'100%'"
    :height="'calc(100% - 60px)'"
  >
    <div @click="clickClosePicker()" slot="content" style="width:100%;height: 100%;overflow: auto;padding: 0 16%;" @scroll="handleScroll">
      <!-- {{editing}} -->
      <!-- class="grid" -->
      <el-form :model="formData" :rules="formRules" ref="form" size="small" class="gridbox">
        <div class="form-group grid">
          <div class="form-groupname">
            <span>{{ $t('datalogger.basic_info') }}</span>
          </div>
          <!-- :label="$t('datalogger.datalogger_pn')" -->
          <!-- <el-form-item label="设备名称：" prop="pn">
            <el-input v-model.trim="formData.pn" :disabled="!!editing" clearable></el-input>
          </el-form-item>-->
          <!-- $t('datalogger.datalogger_name') -->
          <el-form-item :label="`${$t('datalogger.Datalogger_Name')}：`" prop="alias">
            <el-input maxlength="64" v-model="formData.alias" clearable></el-input>
          </el-form-item>
          <!-- 所属项目( 默认项目) -->
          <el-form-item prop="pid" :label="`${$t('project.project')}：`">
            <!-- :placeholder="$t('project.defaultProject')" -->
            <el-select v-model="formData.pid" placeholder popper-class="select-search-recharge">
              <el-option
                v-for="item in pidSelect"
                :key="item.pid"
                :value="item.pid"
                :label="item.pname"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- PN码 -->
          <el-form-item :label="$t('datalogger.datalogger_pn')" prop="pn">
            <el-input
              v-model.trim="formData.pn"
              :disabled="!!editing"
              clearable
              class="pnTipSelect"
              :class="{ 'pnTipDis': !!editing }"
            >
              <template slot="append">
                <!-- width="220" -->
                <el-popover
                  placement="right"
                  @show="showHandle"
                  @hide="hideHandle"
                  trigger="hover"
                  popper-class="pnTipBox"
                >
                  <img src="@/assets/img/general/pnMessage.png" />
                  <i slot="reference" class="iconfont icon-gantanhao pnMessage"></i>
                </el-popover>
              </template>
            </el-input>
          </el-form-item>
          <!-- 额定功率 -->
          <el-form-item prop="nominalPower" :label="`${$t('datalogger.nominalPower')}：`">
            <el-input
              type="number"
              v-model.trim="formData.nominalPower"
              oninput="if(value<0)value=0"
            >
              <!-- <template slot="append"></template> -->
            </el-input>
            <el-dropdown @command="unit => formData.powerUnit = unit" class="glDrop">
              <span class="el-dropdown-link">
                {{ formData.powerUnit.label }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="select-drop-datalogger">
                <el-dropdown-item
                  v-for="unit in availablePowerUnit"
                  :key="unit.label"
                  :command="unit"
                >
                  {{ unit.label
                  }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
          <!-- 安装时间 -->
          <el-form-item prop="installDate" :label="`${$t('datalogger.install_date')}：`">
            <!-- value-format="yyyy-MM-dd HH:mm:ss"  -->
            <div @click.stop="clickClosePicker('val')" style="width: 100%;">
              <el-date-picker
                v-model="formData.installDate"
                type="date"
                :editable="false"
                :clearable="false"
                ref="refInstallDate"
                popper-class="select-date"
              ></el-date-picker>
            </div>
          </el-form-item>
          <!-- 安装商 -->
          <el-form-item prop="installer" :label="`${$t('datalogger.installer')}：`">
            <el-input v-model="formData.installer" clearable></el-input>
          </el-form-item>
        </div>

        <div class="form-group">
          <div class="form-groupname">
            <span>{{ $t('datalogger.location_info') }}</span>
          </div>
          <!-- :label="$t('datalogger.address')" -->
          <el-form-item>
            <div class="map-container">
              <!-- 搜索功能谷歌地图为付费功能 暂时隐藏 -->
              <!-- :placeholder="$t('datalogger.enterPosition')" -->
              <!-- 输入地址搜索电站位置 -->
              <!-- <el-input
                v-if="isCN"
                v-model.trim="addressSearch"
                class="search-address"
                :placeholder="$t('datalogger.enterPosition')"
                @keyup.enter.native="gdsearch"
                clearable
              >
                <el-button slot="append" icon="el-icon-search" @click="gdsearch"></el-button>
              </el-input>-->
              <!-- <div class="map" id="map" v-if="!isCN" ref="map"></div> -->
              <div class="map" id="map" ref="map"></div>
              <!-- 国内原高德(临时用maptalks) -->
              <!-- <div class="map" v-if="isCN" id="GDMap"></div> -->
            </div>
          </el-form-item>
          <el-form-item>
            <!-- 温馨提示：当定位不准或定位失效时可手动输入 -->
            <div style="color:#F56C6C;">{{ $t('datalogger.locationTip') }}</div>
          </el-form-item>
          <el-form-item :label="`${$t('datalogger.longi_lati')}：`" class="latlon" prop="lon">
            <!-- 经度、纬度(只读) -->
            <!-- v-if="formData.lat&&formData.lon" -->
            <!-- <div class="latlonarea">
              <span class="latlonbox">
                {{`${$t('datalogger.longitude')}`}}
                <span class="latloncell">{{formData.lon | formatNum(6)}}</span>
              </span>
              <span class="latlonbox latbox">
                {{`${$t('datalogger.latitude')}`}}
                <span class="latloncell">{{formData.lat | formatNum(6)}}</span>
              </span>
            </div>-->
            <!-- 经度、纬度(可输) -->
            <div class="latlonarea">
              <span class="latlonbox">
                {{ `${$t('datalogger.longitude')}` }}
                <el-input
                  v-model.trim="formData.lon"
                  class="latloncellipt"
                  clearable
                ></el-input>
                <!-- @input="formData.address = '';" -->
              </span>
              <span class="latlonbox">
                {{ `${$t('datalogger.latitude')}` }}
                <el-input
                  v-model.trim="formData.lat"
                  class="latloncellipt"
                  clearable
                ></el-input>
              </span>
            </div>
          </el-form-item>
          <!-- 地理位置 -->
          <el-form-item prop="address" :label="`${$t('datalogger.currentAddress')}`">
            <el-input v-model.trim="formData.address" clearable></el-input>
          </el-form-item>
          <!-- 时区 -->
          <el-form-item prop="timezone" :label="`${$t('datalogger.timezone')}：`">
            <el-select v-model="formData.timezone" popper-class="select-search-recharge">
              <el-option
                v-for="(val, key) in availableTimezone"
                :key="key"
                :label="val.label"
                :value="key"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 令时 -->
          <!-- <el-form-item v-if="formData.timezone=='-36000'||formData.timezone=='-32400'||formData.timezone=='-28800'||formData.timezone=='-25200'||formData.timezone=='-21600'||formData.timezone=='-18000'||formData.timezone=='-14400'||formData.timezone=='-10800'||formData.timezone=='0'||formData.timezone=='3600'||formData.timezone=='7200'||formData.timezone=='43200'" prop="timezoneFlag" :label="`${$t('datalogger.timing')}：`">
            <el-select v-model="formData.timezoneFlag" popper-class="select-search-recharge">
              <el-option v-for="item in availableTiming" :key="item.label" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>-->
          <!-- 国家 -->
          <el-form-item prop="country" :label="`${$t('datalogger.country')}：`">
            <!-- <el-input
              v-if="formData.timezone == '28800'"
              v-model.trim="formData.country"
              clearable
              placeholder="中国"
              disabled
            ></el-input>
            <el-input v-else v-model.trim="formData.country" clearable></el-input> -->
            <el-input v-model.trim="formData.country" clearable></el-input>
          </el-form-item>
          <!-- 省 -->
          <el-form-item prop="province" :label="`${$t('datalogger.province')}：`">
            <el-select
              v-if="formData.timezone == '28800'"
              @change="provinceChange($event)"
              v-model="formData.province"
              popper-class="select-search-recharge"
            >
              <el-option
                v-for="(val) in cityOptions"
                :key="val.name"
                :label="val.name"
                :value="val.name"
              ></el-option>
            </el-select>
            <el-input v-else v-model.trim="formData.province" clearable></el-input>
            <!-- <el-option
                v-for="(val) in cityOptions"
                :key="val.value"
                :label="val.label"
                :value="val.value"
              ></el-option>
            </el-select>-->
          </el-form-item>
          <!-- 市 -->
          <el-form-item prop="city" :label="`${$t('datalogger.city')}：`">
            <el-select
              v-if="formData.timezone == '28800'"
              @change="cityChange($event)"
              v-model="formData.city"
              popper-class="select-search-recharge"
            >
              <el-option
                v-for="(val) in cityList"
                :key="val.name"
                :label="val.name"
                :value="val.name"
              ></el-option>
            </el-select>
            <el-input v-else v-model.trim="formData.city" clearable></el-input>
          </el-form-item>
          <!-- 区 -->
          <el-form-item prop="county" :label="`${$t('datalogger.county')}：`">
            <el-select
              v-if="formData.timezone == '28800'"
              v-model="formData.county"
              popper-class="select-search-recharge"
            >
              <el-option v-for="(val, index) in countyList" :key="index" :label="val" :value="val"></el-option>
            </el-select>
            <el-input v-else v-model.trim="formData.county" clearable></el-input>
          </el-form-item>
        </div>

        <div class="form-group grid">
          <div class="form-groupname">
            <!-- datalogger.income_info -->
            <span>{{ $t('menu.rate') }}</span>
          </div>
          <el-form-item prop="currency" :label="$t('datalogger.currency')">
            <el-select
              v-model="formData.currency"
              placeholder
              popper-class="select-search-recharge"
            >
              <el-option
                v-for="item in availableCurrency"
                :key="item.currency"
                :label="item.label"
                :value="item.currency"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="buyProfit" :label="$t('datalogger.buyProfit')">
            <el-input v-model.trim="formData.buyProfit" clearable></el-input>
          </el-form-item>
          <el-form-item prop="sellProfit" :label="$t('datalogger.sellProfit')">
            <el-input v-model.trim="formData.sellProfit" clearable></el-input>
          </el-form-item>
          <el-form-item prop="unitProfit" :label="$t('datalogger.generateProfit')">
            <el-input v-model.trim="formData.unitProfit" clearable></el-input>
          </el-form-item>
          <!-- 增字段-发电量收益 -->
          <!-- <el-form-item prop="generateProfit" :label="$t('datalogger.generateProfit')">
            <el-input v-model.trim="formData.unitProfit" clearable></el-input>
          </el-form-item>-->
        </div>
      </el-form>
    </div>
    <div slot="footer">
      <!-- <button class="button-hollow" @click="closeDialog">{{$t('datalogger.cancel')}}</button> -->
      <el-button type="text" v-if="editing" class="button-submit" :disabled="submitting" @click="submit">{{ $t('datalogger.confirm') }}</el-button>
      <!-- {{$t('account.submit')}} -->
      <!-- 完成添加 -->
      <el-button type="text" v-else class="button-submit" :disabled="submitting" @click="submit">{{ $t('datalogger.finishAdding') }}</el-button>
    </div>
  </datalogger-dialog>
</template>
<script>
// import markerFault from "@/assets/img/marker_fault.png";
import cityOptions from "../../assets/js/address";
import dataloggerDialog from "./dataloggernewpannel";
import loadMap from "../../views/admin/home/loadMap";

// =======================

// =======================

export default {
  components: {
    dataloggerDialog
  },
  props: {
    visible: {
      default: false
    },
    editing: {
      type: Object,
      default: null
    } // 修改的数采器数据
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.closeDialog();
      }
    },
    visible(val) {
      this.dialogVisible = val;
      // },
      // "formData.timezone"(val){
      //   if(val=='-36000'||val=='-32400'||val=='-28800'||val=='-25200'||val=='-21600'||val=='-18000'||val=='-14400'||val=='-10800'||val=='0'||val=='3600'||val=='7200'||val=='43200'){

      //   }else{
      //     this.formData.timezoneFlag=0
      //   }
    }
  },
  mounted() {
    if (this.isCN) {
      // 国内原高德
      // this.initGDMap();
      // 国内改Leaflet
      // this.initLeaflet();

      this.loadApi();
    } else {
      this.loadApi();
    }
  },
  data() {
    let availablePowerUnit = [
      {
        label: "KW",
        rate: 1
      },
      {
        label: "MW",
        rate: 1000
      },
      {
        label: "GW",
        rate: 1000000
      }
    ]; // 货币
    return {
      // 提交中标志：响应期间禁用提交按钮，防止多接口串行添加时重复提交
      submitting: false,
      // 令时
      // availableTiming:[
      //   {
      //     value:0,
      //     label:this.$t("datalogger.winterTime"),
      //   },
      //   {
      //     value:1,
      //     label:this.$t("datalogger.daylightTiming"),
      //   }
      // ],
      cityOptions: cityOptions, //地址集合
      cityList: [], //市集合
      countyList: [], //区集合
      // 所属项目选择
      pidSelect: [],
      isCN: true,
      plugins: [
        "AMap.Geolocation",
        "AMap.PlaceSearch",
        "AMap.ToolBar",
        "AMap.Scale"
      ],
      // 高德key
      key: "caec1cd654ba87bbea08d61c07f4f8ac",
      // 地图版本
      v: "1.4.15",
      markers: null, // 标记点数据
      city: null,
      mapobjGD: null, //高德地图对象
      dialogVisible: this.visible,
      availablePowerUnit,
      availableTimezone: this.$filter.timezone,
      availableCurrency: this.$filter.currency,
      addressSearch: "",
      formData: {
        // 统一转字符串，与pidSelect选项的pid(字符串)类型一致，避免编辑回显时el-select匹配不上而显示原始id
        pid: this.editing && this.editing.pid != null ? String(this.editing.pid) : "", // 数采器所属项目(pid)
        pname: this.editing ? this.editing.pname : "", // 数采器所属项目(name)
        pn: this.editing ? this.editing.pn : "", // 数采器pn
        alias: this.editing ? this.editing.alias : "", // 数采器别名
        nominalPower: this.editing ? this.editing.profit.nominalPower : "", // 额定功率
        powerUnit: availablePowerUnit[0], // 额定功率单位
        installDate: this.editing
          ? this.editing.address.installDate
          : new Date(), // 安装日期
        installer: this.editing ? this.editing.address.installer : "", // 安装商
        timezone: this.editing ? this.editing.address.timezone + "" : "28800", // 时区
        // timezone: this.editing ?this.editing.timezoneFlag==true? String(this.editing.address.timezone-3600): this.editing.address.timezone + "" : "28800", // 时区
        // timezoneFlag: this.editing ? this.editing.timezoneFlag : 0, // 令时
        currency: this.editing ? this.editing.profit.currency : "￥", // 收益币种
        buyProfit: this.editing ? this.editing.profit.buyProfit : "1.2", // 买电量收益
        sellProfit: this.editing ? this.editing.profit.sellProfit : "1.2", // 卖电量收益
        unitProfit: this.editing ? this.editing.profit.unitProfit : "1.2", // 用电量收益
        lat: this.editing ? this.editing.address.lat : null, // 纬度
        lon: this.editing ? this.editing.address.lon : null, // 经度
        country: this.editing ? this.editing.address.country : "", // 国家
        province: this.editing ? this.editing.address.province : "", // 省
        city: this.editing ? this.editing.address.city : "", // 市/区
        county: this.editing ? this.editing.address.county : "", // 县
        town: this.editing ? this.editing.address.town : "", // 镇
        address: this.editing ? this.editing.address.address : "" // 详细地址
        // address: this.editing ? this.editing.address.address : this.addressSearch, // 详细地址
      },
      // 数采器元信息表单对象(独立于 formData)
      metaForm: {
        devcode: "", // 协议编码
        startAddress: "", // 起始地址
        baudrate: "", // 波特率
        customerCode: "000", // 客户编码
        itemTypeId: "3", // 条目类型ID
        businessId: "3" // 业务ID
      },
      formRules: {
        alias: [
          {
            required: true,
            message: this.$t("datalogger.cp5"),
            trigger: "blur"
          }
        ],
        // pid: [
        //   {
        //     required: true,
        //     message: this.$t("datalogger.cp6"),
        //     trigger: "blur"
        //   }
        // ],
        pn: [
          {
            required: true,
            message: this.$t("message.pn_is_required"),
            trigger: "blur"
          },
          {
            // pattern: /^((?=.*[a-zA-Z])[a-zA-Z\d]{14}){1}([a-zA-Z\d]{4})?$/,
            pattern: /^([A-Z][0-9A-Z]{13}|[A-Z][0-9A-Z]{17})$/,
            message: this.$t("message.PN_info"),
            trigger: "blur"
          }
        ],
        nominalPower: [
          {
            required: true,
            message: this.$t("datalogger.cp3"),
            trigger: "blur"
          }
        ],
        installDate: [
          {
            required: true,
            message: this.$t("datalogger.cp1"),
            trigger: "blur"
          }
        ],
        // 经度
        lon: [
          {
            validator: (rule, value, callback) => {
              var rexlon = /^-?(?:180(?:\.0+)?|1[0-7]\d(?:\.\d+)?|\d{1,2}(?:\.\d+)?)$/
              var rexlat = /^-?(?:90(?:\.0+)?|1[0-7]\d(?:\.\d+)?|\d{1,2}(?:\.\d+)?)$/
              if (value === "") {
                callback(new Error(this.$t("datalogger.cp7")));
              }else if(!rexlon.test(value)){
                callback(new Error(this.$t("datalogger.lonRange")));
              }else if(this.formData.lat ===""){
                callback(new Error(this.$t("datalogger.cp7")));
              }else if(!rexlat.test(this.formData.lat)){
                callback(new Error(this.$t("datalogger.latRange")));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        // 当前位置
        address: [
          {
            required: true,
            message: this.$t("datalogger.cp9"),
            trigger: "blur"
          }
        ],
        timezone: [
          {
            required: true,
            message: this.$t("datalogger.cp2"),
            trigger: "blur"
          }
        ],
        currency: [
          {
            required: true,
            message: this.$t("datalogger.cp4"),
            trigger: "blur"
          }
        ],
        //正数
        buyProfit: [
         {
            pattern: /^(?:0|[1-9]\d*)(?:\.\d+)?$|^(?:0?\.\d+)$/,
            message: this.$t("datalogger.noNegative"),
            trigger: "blur"
          }
        ],
        sellProfit: [
         {
            pattern: /^(?:0|[1-9]\d*)(?:\.\d+)?$|^(?:0?\.\d+)$/,
            message: this.$t("datalogger.noNegative"),
            trigger: "blur"
          }
        ],
        unitProfit: [
          {
            pattern: /^(?:0|[1-9]\d*)(?:\.\d+)?$|^(?:0?\.\d+)$/,
            message: this.$t("datalogger.noNegative"),
            trigger: "blur"
          }
        ]
      },
      // PN码帮助提示
      statusPN: false
    };
  },
  created() {
    console.log(this.editing,"编辑")
    //根据语言切换地图中文为高德 其他为谷歌
    this.$lang.currentLang == "zh_CN"
      ? (this.isCN = true)
      : (this.isCN = false);
    // 获取项目列表
    this.getProjectList();
  },
  methods: {
    handleScroll() {
    // 关闭所有 el-select 下拉
    this.$nextTick(() => {
      document.querySelectorAll('.el-select').forEach(sel => {
        const vueComp = sel.__vue__;
        if (vueComp && vueComp.blur) vueComp.blur();
      });
      // 关闭所有 el-date-picker 弹层
      if (this.$refs.refInstallDate && this.$refs.refInstallDate.hidePicker) {
        this.$refs.refInstallDate.hidePicker();
      }
    });
  },
    // 控制项日期时间选择窗口关闭处理
    clickClosePicker(val) {
      if (!val && this.$refs["refInstallDate"]) {
        this.$refs["refInstallDate"].hidePicker();
      }
    },
    //东八区显示中国
    // provinceChina(){
    //   if(this.formData.timezone=='28800'){
    //     this.formData.country="中国"
    //   }else{
    //     this.formData.country=''
    //   }
    // },
    // 根据选中省，匹配市
    provinceChange(that) {
      this.formData.city = "";
      this.formData.county = "";
      this.cityList = [];
      this.cityOptions.forEach((item, index) => {
        if (item.name == that) {
          this.cityOptions[index].cityList.forEach((item, index) => {
            this.cityList.push(item);
          });
        }
      });
    },
    cityChange(that) {
      // 根据选中省，匹配市
      this.formData.county = "";
      this.countyList = [];
      this.cityList.forEach((item, index) => {
        if (item.name == that) {
          this.cityList[index].areaList.forEach((item, index) => {
            this.countyList.push(item);
          });
        }
      });
    },
    // PN码帮助提示
    showHandle() {
      this.statusPN = true;
    },
    hideHandle() {
      this.statusPN = false;
    },
    //获取项目列表数据
    getProjectList() {
      let param = {
        i18n: this.$lang.currentLang,
        itemType:5,
        businessId: "4"
      };
      // queryPlantCollDevEs
      this.$request.postMicroserDess("/dgm/api/dgm/itemgroupeybond/lists", param).then(res => {
        if (res.code == 0) {
          // console.log('项目列表', res.dat);
          // this.pidSelect = res.data;
          // 兼容：res.data可能为null/非数组，res.data[0].items也可能为null/缺失
          const groupItems = Array.isArray(res.data) && res.data[0] && Array.isArray(res.data[0].items)
            ? res.data[0].items
            : [];
          if(groupItems.length > 0){
            this.pidSelect = groupItems.map(item => ({
              ...item,
              pid: String(item.id),
              pname: item.itemName,
            }));
          }else{
            this.postProject();
          }
          // 非编辑时默认选中第一个；编辑时若传入的pid(如0或无效id)匹配不上任何选项，也回退选中第一个
          if (this.pidSelect.length > 0) {
            const matched = this.pidSelect.some(item => item.pid === this.formData.pid);
            if (!this.editing || !matched) {
              this.formData.pid = this.pidSelect[0].pid;
            }
          }
        } else {
          this.pidSelect = [];
          this.postProject();
        }
      });
    },
    // 创建项目
    postProject() {
      let params = {
        name: "Project" + Date.now() + Math.floor(Math.random() * 1000),
        itemType: 5,
        businessId: "4",
        timezone: this.formData.timezone,
      };
      this.$request.postMicroserDess("/dgm/api/auth/web/itemseybond/saveNewItemForDIS", params).then(res => {
        if (res.code == 0) {
          this.formData.pid = String(res.data);
           this.getProjectList()
        }else{

        }
      });
    },
    /* eslint-disable */
    // 关闭弹窗
    closeDialog() {
      this.submitting = false;
      this.$emit("update:visible", false);
    },
    // 提交
    submit() {
      // 响应中禁止重复提交(添加为多接口串行，中途再点会重复创建)
      if (this.submitting) return;
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitting = true;
          let action = this.editing
              ? "editCollectorEs"
              : // 暂时注释
              this.$store.state.user.role === "2"
              ? "distAddCollectorEs"
              : "addCollectorEs";
          //用于判断不需要改接口    
          if(action == "addCollectorEs"){
            this.getCollectorInfo();
          }else{
            let param = {
              // 所属项目
              pid: this.formData.pid,
              // pname: this.formData.pname,
              pn: this.formData.pn,
              alias: this.formData.alias ? this.formData.alias : " ",
              "address.installer": this.formData.installer
                ? this.formData.installer
                : " ",
              "address.installDate": this.$filter.formatDate(
                this.formData.installDate,
                "yyyy-MM-dd hh:mm:ss"
              ),
              "profit.nominalPower":
                this.formData.nominalPower * this.formData.powerUnit.rate,
              "address.lat": this.formData.lat,
              "address.lon": this.formData.lon,
              // "address.country":
              //   this.$lang.currentLang == "zh_CN"
              //     ? "中国"
              //     : this.formData.country,
              "address.country": this.formData.country,
              "address.province": this.formData.province,
              "address.city": this.formData.city,
              "address.county": this.formData.county,
              "address.town": this.formData.town,
              "address.address": this.formData.address,
              timezone: this.formData.timezone,
              "address.timezone": this.formData.timezone,
              // timezone: this.formData.timezoneFlag==true?String(Number(this.formData.timezone)+3600): this.formData.timezone,
              // timezoneFlag: this.formData.timezoneFlag,
              // "address.timezone":  this.formData.timezoneFlag==true?String(Number(this.formData.timezone)+3600): this.formData.timezone,
              "profit.currency": this.formData.currency,
              "profit.buyProfit": this.formData.buyProfit,
              "profit.sellProfit": this.formData.sellProfit,
              "profit.unitProfit": this.formData.unitProfit
            };
            this.$request.get(action, param).then(res => {
            if (res.err === 0) {
              // 添加成功
              if (action == "editCollectorEs") {
                // console.log('弹窗=>编辑成功');
                this.$emit("submitSuc");
              } else {
                // console.log('弹窗=>编辑外成功');
                this.$emit("submitSucAdd", this.formData.pn);
              }
              this.closeDialog();
            } else {
              // this.$message.error(this.$t(`errCode.${res.err}`));
              // 添加失败
              if (action == "editCollectorEs") {
                // console.log('弹窗=>编辑失败');
                this.$emit("submitFail", this.$t(`errCode.${res.err}`));
              }else if(res.err==522){
                this.$emit(
                  "submitFailAdd",
                  this.$t(`errCode.${res.err}`),
                  res.desc
                );
              } else {
                // console.log('弹窗=>编辑外失败');
                this.$emit(
                  "submitFailAdd",
                  this.$t(`errCode.${res.err}`)
                );
              }
              this.closeDialog();
            }
            }).catch(() => {
              this.submitting = false;
            });
          }    

        }
      });
    },
    // // 获取数采器信息
    getCollectorInfo() {
      this.$request.getMicroserDess("/css/api/auth/web/collectorMetaLoadInfo", { pn: this.formData.pn }).then(res => {
        if (res.code == 0) {
          // this.formData = res.dat;
           this.metaForm.devcode = res.data.protocols;
           this.metaForm.startAddress = res.data.devAddressStatus[0].devaddr;
           this.metaForm.baudrate = res.data.baudrate;
           this.metaForm.customerCode = res.data.customerCode || "000";
           this.metaForm.itemTypeId = res.data.itemTypeId || "5";
           this.metaForm.businessId = "4";
          let parms = {
            pn:this.formData.pn,
            multiDevice:[{
              alias: this.formData.alias,
              devaddr: this.metaForm.startAddress,
            }]
          }
          this.$request.postMicroserDess("/dev/api/auth/valueCloud/dev/checkDevNameAndDevaddr", parms).then((disres) => {
              if (disres.code == 0) {
                 this.addDevice()
                // this.getProject()
              } else {
                 this.$message.error(disres.message);
                 this.submitting = false;
              }
           }).catch(() => {
              this.submitting = false;
           });
        }else{
          this.$message.error(res.message);
          this.submitting = false;
        }
      }).catch(() => {
        this.submitting = false;
      });
    },
    // 添加设备
    addDevice(){
      let params = {
        pn: this.formData.pn,
        alias:  this.formData.alias,
        devaddr: this.metaForm.startAddress,
        baudrate: this.metaForm.baudrate,
        devcodeBind: false,
        customerCode: this.metaForm.customerCode,
        itemTypeId: this.metaForm.itemTypeId,
        businessId: this.metaForm.businessId,
        pitemTypeId: this.metaForm.itemTypeId,
        devcode: this.metaForm.devcode,
        multiDevice: [
          {
            alias: this.formData.alias,
            devaddr: this.metaForm.startAddress,
          }
        ],
        extra: {
          pid: this.formData.pid,
          timezone: this.formData.timezone,
          lat: this.formData.lat,
          lon: this.formData.lon,
          country:this.formData.country,
          address: this.formData.address,
          province: this.formData.province,
          city: this.formData.city,
          town: this.formData.town,
          county: this.formData.county,
          ratingPower: this.formData.nominalPower,
        },
        collectorAttribute:{
              "profit": {
              "nominalPower": this.formData.nominalPower,      // 设计功率/功率单位 kW
              "currency": this.formData.currency || "￥",         // 收益币种
              "buyProfit": this.formData.buyProfit,            // 买电单价（买电量收益）
              "sellProfit": this.formData.sellProfit,           // 卖电单价（卖电量收益），0~1000000
              "unitProfit": this.formData.unitProfit            // 自用单价（用电量收益）
              },
            "address": {
              "installer": this.formData.installer,    // 安装商
              "installDate": this.formData.installDate
                ? this.$filter.formatDate(this.formData.installDate, "yyyy-MM-dd")
                : "" // 安装日期 yyyy-MM-dd
            }
        },
      };
      this.$request.postMicroserDess("/dev/api/auth/valueCloud/dev/device", params).then((res) => {
        if (res.code == 0) {
          this.$emit("submitSucAdd", this.formData.pn);
        }else{
           this.$emit(
             "submitFailAdd",
             this.$t(res.message)
           );
        }
        this.closeDialog();
      }).catch(() => {
        this.submitting = false;
      });
    },
    // 加载google地图api (改用maptalks)
    loadApi() {
      // let id = "googleMap";
      // if (document.getElementById(id)) {
      //   this.initMap();
      // } else {
      //   let url =
      //     document.location.protocol +
      //     `//maps.googleapis.com/maps/api/js?&language=${this.$lang.currentLang}&key=AIzaSyDRbbVGCfXIkdZV0kl0iQoxOicsacoj1sw&sensor=true&libraries=places`;
      //   let script = document.createElement("script");
      //   script.onload = () => {
      //     this.initMap();
      //   };
      //   script.id = id;
      //   document.getElementsByTagName("head")[0].appendChild(script);
      //   script.src = url;
      // }
      // if(this.map){
      //   this.map.remove();
      // }
      var that = this;

      // 天地图逆地理编码：只填充 address 字段
      function tdtReverseGeocode(lon, lat) {
        var url = "https://api.tianditu.gov.cn/geocoder?postStr=" +
          encodeURIComponent(JSON.stringify({ lon: lon, lat: lat, ver: 1 })) +
          "&type=geocode&tk=3fe2e4698b7e162918165e2e087fb119";
        fetch(url)
          .then(function(res) { return res.json(); })
          .then(function(data) {
            if (data && data.status === '0' && data.result) {
              that.formData.address = data.result.formatted_address || '';
            }
          })
          .catch(function() {});
      }

      // 动态加载天地图 SDK
      function loadTMap() {
        return new Promise(function(resolve, reject) {
          if (window.T) { resolve(window.T); return; }
          var script = document.createElement("script");
          script.src = "https://api.tianditu.gov.cn/api?v=4.0&tk=3fe2e4698b7e162918165e2e087fb119";
          script.onload = function() { resolve(window.T); };
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }

      // 定位失败时的默认经纬度(北京)
      var DEFAULT_LON = 116.39128;
      var DEFAULT_LAT = 39.90712;
      // 初始化天地图
      loadTMap().then(function(T) {
        var centerLon = (that.formData.lon != null && that.formData.lon !== '') ? Number(that.formData.lon) : DEFAULT_LON;
        var centerLat = (that.formData.lat != null && that.formData.lat !== '') ? Number(that.formData.lat) : DEFAULT_LAT;
        // 创建天地图实例
        that.map = new T.Map("map");
        that.map.centerAndZoom(new T.LngLat(centerLon, centerLat), 6);

        // 创建初始标记
        var marker = new T.Marker(new T.LngLat(centerLon, centerLat));
        that.map.addOverLay(marker);

        // 新增模式：HTTP/HTTPS 双模兼容定位
        if (!that.editing) {
          // 定位成功后的统一处理
          function handleLocationSuccess(lon, lat) {
            lon = parseInt(lon * 1000000) / 1000000;
            lat = parseInt(lat * 1000000) / 1000000;
            that.formData.lon = lon;
            that.formData.lat = lat;
            var newPos = new T.LngLat(lon, lat);
            that.map.panTo(newPos);
            that.map.setZoom(14);
            marker.setLngLat(newPos);
            tdtReverseGeocode(lon, lat);
          }

          // IP定位（HTTP/HTTPS均可用）
          function ipLocation() {
            fetch('http://ip-api.com/json/?lang=zh-CN')
              .then(function(res) { return res.json(); })
              .then(function(data) {
                if (data && data.status === 'success') {
                  handleLocationSuccess(data.lon, data.lat);
                } else {
                  throw new Error('ip-api failed');
                }
              })
              .catch(function() {
                // 降级方案2
                fetch('https://ipapi.co/json/')
                  .then(function(res) { return res.json(); })
                  .then(function(data) {
                    if (data && data.longitude && data.latitude) {
                      handleLocationSuccess(data.longitude, data.latitude);
                    }
                  })
                  .catch(function(err) {
                    console.warn('所有IP定位方案均失败:', err);
                    // 定位全部失败时回填默认经纬度(北京)，保证表单可提交
                    handleLocationSuccess(DEFAULT_LON, DEFAULT_LAT);
                  });
              });
          }

          // 判断环境：HTTPS 优先浏览器 GPS 定位，失败则降级；HTTP 直接 IP 定位
          if (window.location.protocol === 'https:' && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
              function(pos) {
                handleLocationSuccess(pos.coords.longitude, pos.coords.latitude);
              },
              function(err) {
                console.warn('浏览器定位失败，降级IP定位:', err.message);
                ipLocation();
              },
              { enableHighAccuracy: true, timeout: 10000 }
            );
          } else {
            // HTTP 环境直接使用 IP 定位
            ipLocation();
          }
        }

        // 点击地图事件
        that.map.addEventListener("click", function(e) {
          var lnglat = e.lnglat;
          var lng = parseInt(lnglat.getLng() * 1000000) / 1000000;
          var lat = parseInt(lnglat.getLat() * 1000000) / 1000000;
          // 移动标记（直接使用天地图坐标）
          marker.setLngLat(lnglat);
          // 直接使用天地图返回坐标填入表单
          that.formData.lon = lng;
          that.formData.lat = lat;
          tdtReverseGeocode(lng, lat);
        });
      }).catch(function() {
        // 天地图 SDK 加载失败，不影响其他功能；仍回填默认经纬度(北京)，仅新增模式
        if (!that.editing) {
          that.formData.lon = DEFAULT_LON;
          that.formData.lat = DEFAULT_LAT;
          // 逆地理是独立fetch(不依赖SDK)，best-effort补地址；失败内部已吞掉，无副作用
          tdtReverseGeocode(DEFAULT_LON, DEFAULT_LAT);
        }
      });
      // }
      // else {
      //   // [#maptlks(GDMap)#]
      //   // console.log("[maptlks-init(GDMap)]");
      //   // 用高德地图进行本机定位，然后赋值到google地图坐标系中
      //   loadMap(this.key, this.plugins, this.v)
      //     .then(AMap => {
      //       var that = this;
      //       var GDMap;
      //       GDMap = new AMap.Map("GDMap", {
      //         resizeEnable: true
      //       });
      //       AMap.plugin("AMap.Geolocation", function() {
      //         var geolocation = new AMap.Geolocation({
      //           // 是否使用高精度定位，默认:true
      //           enableHighAccuracy: true,
      //           // 超过10秒(10000)后停止定位，默认：5s
      //           timeout: 30000,
      //           // 定位按钮的停靠位置
      //           buttonPosition: "RB",
      //           // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
      //           buttonOffset: new AMap.Pixel(10, 20),
      //           // 定位成功后是否自动调整地图视野到定位点
      //           zoomToAccuracy: true,
      //           showMarker: false,
      //           panToLocation: true
      //         });
      //         GDMap.addControl(geolocation);
      //         // 获取定位 (失效)
      //         // geolocation.getCurrentPosition
      //         // 获取城市
      //         geolocation.getCityInfo(function(status, result) {
      //           // console.log("[GDMap-status(1)]", status);
      //           // console.log("[GDMap-result(1)]", result);

      //           // status == "complete"
      //           if (status == "complete" && result.info == "SUCCESS") {
      //             // that.formData.lat = result.position.lat
      //             // that.formData.lon = result.position.lng
      //             // [增(当前地址)]???
      //             // that.addressSearch = result.formattedAddress;
      //             // that.formData.address = result.formattedAddress;
      //             // that.$set(that.formData, 'address', result.formattedAddress);

      //             // [城市中心]
      //             that.formData.lon = result.center[0];
      //             that.formData.lat = result.center[1];
      //             that.addressSearch = result.city;
      //             that.city = result.province;
      //             that.formData.address = result.country + result.province + result.city;
      //           } else {
      //             that.formData.lat = 39.909604
      //             that.formData.lon = 116.397228
      //             // that.onError(result);
      //           }
      //           let position = {
      //             lat: that.formData.lat - 0,
      //             lng: that.formData.lon - 0
      //           };
      //           let mapCenter = gcj02_to_wgs84(
      //             parseFloat(position.lng),
      //             parseFloat(position.lat)
      //           );
      //           that.map.setCenter({x:mapCenter[0],y:mapCenter[1]})
      //           var marker = new maptalks.Marker(
      //             [mapCenter[0], mapCenter[1]],
      //             {
      //               symbol : {
      //                 markerFile: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_bs.png',
      //                 markerDx: 0,
      //                 markerDy: 0,
      //                 markerOpacity: 1
      //               }
      //             }
      //           );
      //           var layer = new maptalks.VectorLayer('vector', [marker])
      //             .addTo(that.map);

      //           // 点击
      //           that.map.on('click', function (e) {
      //             // [#maptlks(GDMap)#]
      //             // console.log("[maptlks-click]");
      //             // console.log("[maptlks-click(e)]", e);
      //             // console.log("[maptlks-click-x]", e.coordinate.x);
      //             // console.log("[maptlks-click-y]", e.coordinate.y);

      //             // 先清除位置 (后面重新赋值) .........................
      //             that.addressSearch = '';
      //             that.formData.address = '';

      //             // [maptalks获取经纬度使用GDMap进行搜索位置] ..........
      //             // GDMap.plugin("AMap.Geocoder", function() {
      //             //   let geocoder = new AMap.Geocoder({
      //             //     radius: 100,
      //             //     extensions: "all"
      //             //   });
      //             //   geocoder.getAddress(
      //             //     // [GDMap经纬度]
      //             //     // [e.lnglat.lng, e.lnglat.lat],
      //             //     // [maptalks经纬度]
      //             //     [e.coordinate.x, e.coordinate.y],
      //             //     function(status, result) {
      //             //       // [#maptlks(GDMap)#]
      //             //       console.log("[maptlks(GDMap)-status(4)]", status);
      //             //       console.log("[maptlks(GDMap)-result(4)]", result);
      //             //       if (status === "complete" && result.info === "OK") {
      //             //         that.addressSearch = result.regeocode.formattedAddress;
      //             //         // that.city = result.regeocode.addressComponent.province;
      //             //         that.formData.address = that.addressSearch;
      //             //       }
      //             //     }
      //             //   );
      //             // });
      //             // ....................................................

      //             that.map.removeLayer(layer)
      //             marker = new maptalks.Marker(
      //               [e.coordinate.x, e.coordinate.y],
      //               {
      //                 symbol : {
      //                   markerFile: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_bs.png',
      //                   markerDx: 0,
      //                   markerDy: 0,
      //                   markerOpacity: 1
      //                 }
      //               }
      //             );
      //             layer = new maptalks.VectorLayer('vector', [marker])
      //               .addTo(that.map);
      //             // WGS-84国际标准
      //             // GCJ-02中国坐标偏移标准(Google Map、高德、腾讯使用)
      //             mapCenter = wgs84_to_gcj02(
      //               parseFloat(e.coordinate.x),
      //               parseFloat(e.coordinate.y)
      //             );
      //             // that.formData.lon = mapCenter[0];
      //             // that.formData.lat = mapCenter[1];
      //             // console.log("[maptlks-click-mapCenter]", mapCenter);
      //             that.formData.lon = parseInt(mapCenter[0]*1000000)/1000000;
      //             that.formData.lat = parseInt(mapCenter[1]*1000000)/1000000;
      //           });
      //         });
      //       });
      //     })
      //     .catch(() => {
      //       console.log("地图加载失败！");
      //     });
      // }
    },
    // ===国内改Leaflet===============================================
    // initLeaflet(){
    //   console.log("【initLeaflet】");
    // },
    // ===国内原高德==================================================
    //初始化高德地图
    initGDMap() {
      loadMap(this.key, this.plugins, this.v)
        .then(AMap => {
          var that = this;
          var GDMap;
          GDMap = new AMap.Map("GDMap", {
            resizeEnable: true
          });
          this.mapobjGD = GDMap;
          if (this.formData.lat && this.formData.lon) {
            // [#GDMap#]
            // console.log("[GDMap-init-edit]");
            AMap.plugin("AMap.Geolocation", function() {
              var geolocation = new AMap.Geolocation({
                // 是否使用高精度定位，默认:true
                enableHighAccuracy: true,
                // 定位按钮的停靠位置
                buttonPosition: "RB",
                showMarker: false,
                // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见
                panToLocation: true
              });
              GDMap.addControl(geolocation);
            });
            that.marker = new AMap.Marker({
              position: new AMap.LngLat(this.formData.lon, this.formData.lat)
            });
            GDMap.add(that.marker);
            GDMap.setFitView();
          } else {
            // [#GDMap#]
            // console.log("[GDMap-init-create]");
            AMap.plugin("AMap.Geolocation", function() {
              var geolocation = new AMap.Geolocation({
                // 是否使用高精度定位，默认true
                enableHighAccuracy: true,
                // 超过10秒(10000)后停止定位，默认5s
                timeout: 30000,
                // 定位按钮的停靠位置
                buttonPosition: "RB",
                // 定位按钮与设置的停靠位置的偏移量，默认Pixel(10, 20)
                buttonOffset: new AMap.Pixel(10, 20),
                // 定位成功后是否自动调整地图视野到定位点
                zoomToAccuracy: true,
                showMarker: false,
                panToLocation: true,
                // [增]定位成功后用圆圈表示定位精度范围，默认true
                showCircle: false
              });
              GDMap.addControl(geolocation);

              // console.log("[GDMap-init-getCityInfo]");
              // 获取定位 (失效)
              // geolocation.getCurrentPosition
              // 获取城市
              geolocation.getCityInfo(function(status, result) {
                // console.log("[GDMap-status(2)]", status);
                // console.log("[GDMap-result(2)]", result);
                // console.log("[GDMap-result.info(2)]", result.info);

                // status == "complete"
                if (status == "complete" && result.info == "SUCCESS") {
                  // that.formData.lat = result.position.lat;
                  // that.formData.lon = result.position.lng;
                  // that.addressSearch = result.formattedAddress;
                  // that.city = result.addressComponent.province;
                  // that.formData.address = result.formattedAddress;

                  // [城市中心]
                  that.formData.lon = result.center[0];
                  that.formData.lat = result.center[1];
                  that.addressSearch = result.city;
                  that.city = result.province;
                  that.formData.address =
                    result.country + result.province + result.city;

                  // [当前位置(bounds)？]
                  // console.log("[GDMap-result.bounds[0]]", result.bounds[0]);
                  // console.log("[GDMap-result.bounds[1]]", result.bounds[1]);

                  // that.formData.lon = result.bounds[0];
                  // that.formData.lat = result.bounds[1];
                  // that.addressSearch = result.city;
                  // that.city = result.province;
                  // that.formData.address = result.country + result.province + result.city;

                  // 解析定位结果
                  that.onComplete(result);
                  // [覆盖物marker]
                  that.marker = new AMap.Marker({
                    position: new AMap.LngLat(
                      // result.position.lng,
                      // result.position.lat,

                      // [城市中心]
                      result.center[0],
                      result.center[1]

                      // [当前位置(bounds)？]
                      // result.bounds[0],
                      // result.bounds[1],
                    )
                  });
                  GDMap.add(that.marker);
                } else {
                  // 解析定位错误信息
                  that.onError(result);
                }
              });
            });
          }
          this.GDMap = GDMap;
          GDMap.on("complete", () => {
            //地图初始化完成执行
            AMap.event.addListener(GDMap, "click", function(e) {
              // [#GDMap#]
              // console.log("[GDMap-click]");
              if (that.marker) {
                GDMap.remove(that.marker);
              }
              that.marker = new AMap.Marker({
                position: new AMap.LngLat(e.lnglat.lng, e.lnglat.lat)
              });
              var reconnaissance = new AMap.LngLat(e.lnglat.lng, e.lnglat.lat);
              that.formData.lat = reconnaissance.lat;
              that.formData.lon = reconnaissance.lng;

              GDMap.plugin("AMap.Geocoder", function() {
                let geocoder = new AMap.Geocoder({
                  radius: 100,
                  extensions: "all"
                });
                geocoder.getAddress([e.lnglat.lng, e.lnglat.lat], function(
                  status,
                  result
                ) {
                  if (status === "complete" && result.info === "OK") {
                    that.addressSearch = result.regeocode.formattedAddress;
                    that.city = result.regeocode.addressComponent.province;
                    that.formData.address = that.addressSearch;

                    // 补充字段(国家/省/市/区)
                    that.formData.country =
                      result.regeocode.addressComponent.country;
                    that.formData.province =
                      result.regeocode.addressComponent.province;
                    that.formData.city = result.regeocode.addressComponent.city;
                    that.formData.town =
                      result.regeocode.addressComponent.district;
                  }
                });
              });

              GDMap.add(that.marker);
            });
          });
        })
        .catch(() => {
          // console.log("地图加载失败！");
        });
    },
    //高德地图搜索
    gdsearch() {
      // this.initGDMap();
      this.placeSearch(this.addressSearch);
      this.formData.address = this.addressSearch;
    },
    //高德地图根据名字地址去搜索结果
    placeSearch(name) {
      let that = this;
      var MSearch;
      this.mapobjGD.plugin(
        ["AMap.PlaceSearch", "AMap.ToolBar", "AMap.Scale"],
        () => {
          this.mapobjGD.addControl(new AMap.ToolBar());
          this.mapobjGD.addControl(new AMap.Scale());
          MSearch = new AMap.PlaceSearch({
            //构造地点查询类
            city: that.city //城市
          });
          AMap.event.addListener(
            MSearch,
            "complete",
            this.keywordSearch_CallBack
          ); //返回地点查询结果
          MSearch.search(name); //关键字查询
        }
      );
    },
    //高德地图结果的回调
    keywordSearch_CallBack(data) {
      if (data.poiList.pois.length != 0) {
        var poiArr = data.poiList.pois[0].location;
        if (this.marker) {
          this.mapobjGD.remove(this.marker);
        }
        this.marker = new AMap.Marker({
          position: new AMap.LngLat(poiArr.lng, poiArr.lat)
        });
        this.formData.lat = poiArr.lat;
        this.formData.lon = poiArr.lng;
        this.mapobjGD.add(this.marker);
        this.mapobjGD.setFitView();
      } else {
        if (this.isCN) {
          this.initGDMap();
        } else {
          this.loadApi();
        }
      }
    },
    // Google初始化地图 ==========
    initMap() {
      if (typeof google === "undefined") {
        setTimeout(() => {
          this.initMap();
        }, 500);
        return;
      }
      var that = this;
      that.map = new google.maps.Map(this.$refs.map, {
        center: {
          lat: (that.formData.lat != null && that.formData.lat !== '') ? Number(that.formData.lat) : 39.90712,
          lng: (that.formData.lon != null && that.formData.lon !== '') ? Number(that.formData.lon) : 116.39128
        },
        zoom: 16,
        mapTypeControl: false, //地图类型控件
        streetViewControl: false //街景小人控件图标
      });
      if (this.formData.lat && this.formData.lon) {
        let position = {
          lat: that.formData.lat - 0,
          lng: that.formData.lon - 0
        };
        let latLng = new google.maps.LatLng(
          that.formData.lat,
          that.formData.lon
        );
        that.map.setCenter(latLng);
        that.marker = new google.maps.Marker({
          map: that.map,
          position: position
        });
        that.formData.lat = position.lat;
        that.formData.lon = position.lng;
        that.map.addListener("click", e => {
          if (that.marker) {
            that.marker.setMap(null);
          }
          let position = {
            lat: e.latLng.lat() - 0,
            lng: e.latLng.lng() - 0
          };
          that.marker = new google.maps.Marker({
            map: that.map,
            position: position
          });
          that.formData.lat = position.lat;
          that.formData.lon = position.lng;
        });
      } else {
        // 用高德地图进行本机定位，然后赋值到google地图坐标系中
        loadMap(this.key, this.plugins, this.v)
          .then(AMap => {
            var that = this;
            var GDMap;
            GDMap = new AMap.Map("GDMap", {
              resizeEnable: true
            });
            AMap.plugin("AMap.Geolocation", function() {
              var geolocation = new AMap.Geolocation({
                enableHighAccuracy: true, //是否使用高精度定位，默认:true
                timeout: 10000, //超过10秒后停止定位，默认：5s
                buttonPosition: "RB", //定位按钮的停靠位置
                buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
                showMarker: false,
                panToLocation: true
              });
              GDMap.addControl(geolocation);
              geolocation.getCurrentPosition(function(status, result) {
                // console.log("[GDMap-status(3)]", status);
                // console.log("[GDMap-result(3)]", result);

                if (status == "complete") {
                  that.formData.lat = result.position.lat;
                  that.formData.lon = result.position.lng;
                } else {
                  that.formData.lat = 39.909604;
                  that.formData.lon = 116.397228;
                  // that.onError(result);
                }
                let position = {
                  lat: that.formData.lat - 0,
                  lng: that.formData.lon - 0
                };
                let latLng = new google.maps.LatLng(position.lat, position.lng);
                that.map.setCenter(latLng);
                that.marker = new google.maps.Marker({
                  map: that.map,
                  position: position
                });
                // that.formData.lat = position.lat;
                // that.formData.lon = position.lng;
                that.map.addListener("click", e => {
                  if (that.marker) {
                    that.marker.setMap(null);
                  }
                  let position = {
                    lat: e.latLng.lat() - 0,
                    lng: e.latLng.lng() - 0
                  };
                  that.marker = new google.maps.Marker({
                    map: that.map,
                    position: position
                  });
                  that.formData.lat = position.lat;
                  that.formData.lon = position.lng;
                });
              });
            });
          })
          .catch(() => {
            // console.log("地图加载失败！");
          });

        // if (navigator.geolocation) {
        //   navigator.geolocation.getCurrentPosition(
        //     function(positionStatus) {
        //       let position = {
        //         lat: positionStatus.coords.latitude - 0,
        //         lng: positionStatus.coords.longitude - 0
        //       };
        //       let latLng = new google.maps.LatLng(position.lat, position.lng);
        //       that.map.setCenter(latLng);
        //       that.marker = new google.maps.Marker({
        //         map: that.map,
        //         position: position
        //       });
        //       that.formData.lat = position.lat;
        //       that.formData.lon = position.lng;
        //       that.map.addListener("click", e => {
        //         if (that.marker) {
        //           that.marker.setMap(null);
        //         }
        //         console.log("google",e)
        //         let position = {
        //           lat: e.latLng.lat() - 0,
        //           lng: e.latLng.lng() - 0
        //         };
        //         that.marker = new google.maps.Marker({
        //           map: that.map,
        //           position: position
        //         });
        //         that.formData.lat = position.lat;
        //         that.formData.lon = position.lng;
        //       });
        //     },
        //     function(err) {
        //       //传入了error对象
        //       console.log("err",err)
        //       // GetID.innerHTML = err.code + "\n" + err.message; //Firefox3.6以上不支持error对象的message属性
        //       //error对象的code属性有如下属性值:
        //       //PERMISSION_DENIED(1):(permission_denied):用户单机信息条上的“不共享”按钮或直接拒绝被获取位置信息
        //       //POSITION_UNAVAILABLE(2):(position_unavailable):(position_unavailable)网络不可用或者无法连接到获取位置信息的卫星
        //       //TIMEOUT(3):(timeout)网络可用但在计算机用户的位置上花费过长时间
        //       //UNKNOWN_ERROR(0):(unknown_error)发生其他未知错误
        //     }
        //   );
        // } else {
        //   console.log("定位失败");
        // }
      }
    },
    // ==========================
    // 输入地址后搜索
    // search() {
    //   let geocoder = new google.maps.Geocoder();
    //   geocoder.geocode({ address: this.addressSearch }, (results, status) => {
    //     if (status == "OK") {
    //       let place = results[0];
    //       if (place.geometry.viewport) {
    //         this.map.fitBounds(place.geometry.viewport);
    //       } else {
    //         this.map.setCenter(place.geometry.location);
    //         this.map.setZoom(17);
    //       }
    //       this.getAddress(place.geometry.location);
    //       this.$refs.map.scrollIntoView({
    //         behavior: "smooth"
    //       });
    //     }
    //   });
    // },

    // 根据经纬度获取地址详情
    // getAddress(latLng) {
    //   let geocoder = new google.maps.Geocoder();
    //   geocoder.geocode({ location: latLng }, (results, status) => {
    //     if (status == google.maps.GeocoderStatus.OK) {
    //       this.formData.lat = latLng.lat();
    //       this.formData.lon = latLng.lng();

    //       // 查找国家、省、市、区并赋值
    //       let country = "",
    //         province = "",
    //         city = "",
    //         town = "";
    //       results[0].address_components.forEach(address => {
    //         if (address.types.indexOf("country") > -1) {
    //           this.formData.country = country = address.long_name;
    //         } else if (
    //           address.types.indexOf("administrative_area_level_1") > -1
    //         ) {
    //           this.formData.province = province = address.long_name;
    //         } else if (address.types.indexOf("locality") > -1) {
    //           this.formData.city = city = address.long_name;
    //         } else if (address.types.indexOf("sublocality") > -1) {
    //           this.formData.town = town = address.long_name;
    //         }
    //       });
    //       let components = [town, city, province, country].filter(
    //         item => !!item
    //       );
    //       this.formData.address =
    //         this.$lang.currentLang === "zh_CN"
    //           ? components.reverse().join("")
    //           : components.join(",");
    //       this.attachMarker(latLng);
    //     }
    //   });
    // },
    // // google添加地图标记
    // attachMarker(position) {
    //   // 移除已有标记
    //   this.marker && this.marker.setMap(null);
    //   this.map.setCenter(position);
    //   this.marker = new google.maps.Marker({
    //     map: this.map,
    //     position,
    //     icon: markerFault
    //   });
    // },

    //解析定位结果
    onComplete(data) {
      // [#GDMap#]
      // console.log("[GDMap-onComplete]");
      var str = [];
      str.push("定位结果：" + data.position);
      str.push("定位类别：" + data.location_type);
      if (data.accuracy) {
        str.push("精度：" + data.accuracy + " 米");
      } //如为IP精确定位结果则没有精度信息
      str.push("是否经过偏移：" + (data.isConverted ? "是" : "否"));
    },
    //解析定位错误信息
    onError(data) {
      // [#GDMap#]
      // console.log("[GDMap-onError]");
      // console.log("定位失败");
      // console.log(data.message);
      // alert("定位失败" + data.message);
    }
  }
};
</script>
<style lang="less">
@import url("../../assets/css/mixin.less");

.dataloggerDialog {
  .search-address {
    .el-input__inner {
      border: none;
      // box-shadow: 2px 2px 2px @themeColor inset;
    }

    .el-input-group__append {
      background: @themeBg;
      color: #fff;
      padding: 0;
      border: none;

      button {
        padding: 0 26px;
        line-height: 32px;
        font-size: 14px;
      }
    }
  }
}

.select-search-datalogger {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border: none;

  // min-width: 120px;
  // width: 120px;
  .el-select-dropdown__item {
    color: #ffffff;
  }

  .hover,
  .el-select-dropdown__item:hover,
  .el-select-dropdown__item.selected {
    background-color: transparent;
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px 20px 0px 0px;
  }
}

// #功率 el-drop#
.select-drop-datalogger {
  border: none;
  background-color: #222d35;
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  padding: 8px 0px;

  .el-dropdown-menu__item,
  .el-dropdown-menu__item:focus {
    padding: 0px 16px;
    border: none;
    background-color: #222d35;
    color: rgba(255, 255, 255, 1);
  }

  .el-dropdown-menu__item:hover {
    padding: 0px 16px;
    background-color: #222d35;
    color: rgba(255, 255, 255, 1);
  }

  .el-dropdown-menu__item:not(:last-child) {
    padding: 0px 16px;
    border: none;
  }
}

// #PN码帮助提示#
.pnTipBox.el-popover {
  padding: 10px;
  border: none;
  background: #1e2e35;
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
}

.pnTipBox.el-popover .popper__arrow {
  border-right-color: #1e2e35;
}

.pnTipBox.el-popover .popper__arrow::after {
  border-right-color: #1e2e35;
}

.pnTipBox.el-popper[x-placement^="left"] .popper__arrow {
  border-right-width: 0;
  border-left-color: #1e2e35;
}

.pnTipBox.el-popper[x-placement^="left"] .popper__arrow::after {
  border-right-width: 0;
  border-left-color: #1e2e35;
}

// #额定功率#
.glDrop {
  .el-dropdown-link {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    margin-left: 10px;
    border: 1px solid #a3a9b5;
    border-radius: 4px;
    background: rgba(43, 56, 66, 1);
    color: rgb(255, 255, 255);
  }

  .el-icon-arrow-down:before {
    color: rgb(56, 165, 118);
  }
}

.select-date.el-popper[x-placement^="top"] .popper__arrow {
  display: none;
}

.select-date.el-popper[x-placement^="right"] .popper__arrow {
  display: none;
}

.select-date.el-popper[x-placement^="bottom"] .popper__arrow {
  display: none;
}

.select-date.el-popper[x-placement^="left"] .popper__arrow {
  display: none;
}

// #下拉选框#
.select-search-recharge {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 4px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 16px;
    right: 0px;
  }
}
</style>
<style lang="less" scoped>
@import url("../../assets/css/mixin.less");

.dialog-modal.dataloggerDialog.addDeviceBox {
  // height: 100%;
  // background: #222D35!important;
  /deep/.el-form-item__content {
    display: flex;
  }

  /deep/.dialog-content .el-form-item--small .el-form-item__label {
    // width: 10%;
    line-height: 40px;
  }

  /deep/.latlon .el-form-item__content {
    display: block;
  }

  // .dialog-content .el-form-item--small.latlon .el-form-item__label {
  //   display: block;
  //   width: 100%;
  //   text-align: left;
  //   line-height: 40px;
  // }
  /deep/.linkage .el-form-item__content {
    display: block;
  }

  /deep/.dialog-content .el-form-item--small.linkage .el-form-item__label {
    display: block;
    width: 100%;
    text-align: left;
    line-height: 40px;
  }

  /deep/.el-icon-arrow-up:before {
    color: @primaryTextColor;
  }

  // 时间图标
  // /deep/.el-icon-date:before {
  //   color: @primaryTextColor;
  // }
  /deep/.el-icon-date:before {
    content: "";
    display: inline-block;
    // position: absolute;
    // top: 12px;
    // left: 0px;
    margin-top: 8px;
    height: 24px;
    width: 24px;
    background: url(../../assets/img/general/Icon_Calendar.png) no-repeat;
    background-size: 100%;
    background-position: center;
  }
  .button-submit {
    font-size: 14px;
    padding: 10px 10px;
    border-radius: 5px;
    margin: 0 6px;
    background-color: #16D09A;
    color: #202D35;
    border: none;
  }
}

.gridbox {
  flex: 1;
  // overflow: auto;

  // padding: 0 0 15px 15px;
  .grid {
    grid-row-gap: 28px;

    /deep/.el-form-item--small .el-form-item__error {
      padding-top: 6px;
    }
  }

  .form-group {
    padding: 49px 46px 31px;
    margin-top: 50px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 16px;
    position: relative;

    /deep/.el-input .el-input__inner {
      height: 40px;
      line-height: 40px;
    }

    /deep/.el-input-group__append,
    /deep/.el-input-group__prepend {
      background: #2b3842;

      .el-dropdown {
        color: #ffffff;
      }

      .el-icon-arrow-down:before {
        color: @primaryTextColor;
      }
    }

    // PN码帮助提示
    .pnMessage {
      color: @primaryTextColor;
      cursor: pointer;
    }

    .pnTipSelect {
      border: 1px solid #a3a9b5;
      border-radius: 4px;

      /deep/.el-input-group__append,
      /deep/.el-input-group__prepend {
        border: none;
      }

      /deep/.el-input__inner {
        border: none;
      }
    }

    .pnTipSelect.pnTipDis {
      border: none;
      border-radius: 4px;

      /deep/.el-input-group__append,
      /deep/.el-input-group__prepend {
        border: none;
      }

      /deep/.el-input .el-input__inner {
        border: none;
      }
    }

    // 经纬度
    .latlonarea {
      display: flex;

      .latlonbox {
        display: inline-block;

        // 只读
        .latloncell {
          display: inline-block;
          padding: 3px 16px;
          margin-right: 30px;
          margin-left: 10px;
          border-radius: 4px;
          border: 1px solid rgba(204, 206, 221, 1);
          background: rgba(43, 56, 66, 1);

          /deep/.el-input__inner {
            height: 40px;
            line-height: 40px;
          }
        }

        // 可输
        .latloncellipt {
          display: inline-block;
          width: 60%;
          border-radius: 4px;
          background: rgba(43, 56, 66, 1);
          margin-left: 5px;

          /deep/.el-input__inner {
            height: 40px;
            line-height: 40px;
          }
        }
      }

      .latbox {
        text-align: right;
      }
    }

    // 省市联动
    .linkagebox {
      .linkagecell {
        margin-right: 10px;

        .el-select {
          width: 19%;
        }
      }
    }
  }

  .form-groupname {
    position: absolute;
    top: -20px;
    left: 50px;
    .sc(26px, #ffffff);
    font-weight: 600;
    background: #222d35;
    padding: 0 8px;
    // grid-column: 1 / span 2;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // margin-left: -15px;
  }

  .map-container {
    width: 100%;
    // height: 30vh;
    height: 258px;
    position: relative;

    .search-address {
      position: absolute;
      top: 20px;
      left: 50px;
      width: 86%;
      z-index: 2;
      box-shadow: 2px 2px 11px #cccccc;

      /deep/&.el-input .el-input__inner {
        background: #ffffff;
        box-shadow: none;
        color: #a3a9b5;
      }
    }

    .map {
      height: 100%;
      // border-radius: 10px 10px 0 0;
    }
  }

  .address {
    padding: 10px 15px;
    background: #f2f2f2;
    .sc(12px, #333);
    line-height: 1.8;

    .address-item {
      &:not(:last-child) {
        margin-right: 15px;
      }
    }

    .address-input_container {
      display: flex;
      align-items: center;

      .address-input {
        flex: 1;
      }
    }
  }
}
/* 隐藏天地图左下角的版权信息 */
/deep/ .tdt-control-copyright {
    display: none !important;
}
</style>
